export default "__VITE_ASSET__BmKw9wMV__"